
import { mixins } from 'vue-class-component';
import { Online } from '@/components/mixins/online';
import { SchemeScope } from '@/components/mixins/schemescope';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AddLessonPlanForm extends mixins(Online, SchemeScope) {
  private adding = false;
  private saving = false;
  private newSessionName = '';

  @Prop({ default: '' }) prefix!: string;

  get nameRules() {
    return [
      (v: string) => !!v || this.$t('validation.required'),
      (v: string) => (v && v.length <= 50) || this.$tc('validation.too_many_characters', 50),
    ];
  }

  get canAddSession() {
    return this.$store.getters['auth/isFeatureEnabled']('CAN_ADD_SESSION_PLAN');
  }

  showForm() {
    this.newSessionName = this.prefix;
    this.adding = true;
  }

  async createSession() {
    try {
      this.saving = true;
      const newUuid = await this.$store.dispatch('planning/createItem', {
        title: this.newSessionName,
        slug: this.slug,
      });
      this.$alert('success', this.$t('planning.session_created') as string);
      this.newSessionName = '';
      this.adding = false;
      this.$emit('created', newUuid);
    } catch (error) {
      this.$alert('error', error as string);
    } finally {
      this.saving = false;
    }
  }
}
